// PixMMO heroes, generated by scripts/render-heroes.ts from the game's avatar
// engine: sheets in assets/sprites/heroes/<id>-<run|idle>.png (32x32 frames).
// run/idle: [frames, fps, cx, cy, crop], a tight square around the art.

export const HERO_FRAME = 32;
export const HEROES = {
  adventurer: {
    name: 'Adventurer',
    run: [4, 10, 18.5, 18.5, 27],
    idle: [12, 6, 18, 19, 26]
  },
  adventuress: {
    name: 'Adventuress',
    run: [4, 10, 18.5, 18.5, 27],
    idle: [12, 6, 18, 19, 26]
  },
  knight: {
    name: 'Knight',
    run: [4, 10, 18, 18, 28],
    idle: [12, 6, 17.5, 18.5, 27]
  },
  mage: {
    name: 'Mage',
    run: [4, 10, 16, 16, 32],
    idle: [12, 6, 16, 16, 32]
  },
  angel: {
    name: 'Angel',
    run: [4, 10, 16, 16, 32],
    idle: [12, 6, 16, 16, 32]
  },
  pumpkin: {
    name: 'Pumpkin Hero',
    run: [4, 10, 18, 18, 28],
    idle: [12, 6, 18.5, 18.5, 27]
  },
  witch: {
    name: 'Witch',
    run: [4, 10, 16, 16, 32],
    idle: [12, 6, 16, 16, 32]
  }
};
flarum.reg.add('soup-97-pixmmo-pixelui', 'common/heroes', { HERO_FRAME: HERO_FRAME,HEROES: HEROES, });